import {Loader} from 'google-maps';
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import Request from "@wwdev/bootstrap/Request";
import ClusterRenderer from "./ClusterRenderer";

class GoogleMaps {
	loader;
	google;
	google_api_key;
	infoWindow;
	advancedMarkerElement;
	markers = [];
	dealers = {};
	defaultPosition = {lat: 52.3682393, lng: 4.9006605};
	cluster;
	bounds;
	request;
	clustertitle;

	constructor(config) {
		this.config = Object.assign({
			scope: '[data-google-maps="scope"]',
			map: '[data-google-maps="map"]',
		}, config);
		this.$scope = $(this.config.scope);
		if (this.$scope.length > 0) {
			this.google_api_key = $('meta[name="google_client_side_key"]').attr('content');
			this.clustertitle = $('meta[name="google_clustertitle"]').attr('content');
		}
	}

	init() {
		return this.initMap();
	}

	async initMap() {
		this.request = new Request();
		this.loader = new Loader(this.google_api_key);
		this.google = await this.loader.load();
		this.map = new this.google.maps.Map(this.$scope.find(this.config.map)[0], {
			center: this.defaultPosition,
			zoom: 8,
			zoomControl: true,
			cameraControl: false,
			mapTypeControl: false,
			streetViewControl: false,
			mapId: '389e0e3fe18366a3c171a681'
		});
		const {AdvancedMarkerElement} = await this.google.maps.importLibrary("marker");
		this.advancedMarkerElement = AdvancedMarkerElement;
		ClusterRenderer.google = this.google;
		this.cluster = new MarkerClusterer({
			map: this.map,
			markers: this.markers,
			renderer: ClusterRenderer,
		});
	}

	setMarkers(markers) {
		this.dealers = markers;
		this.resetMarkers().then(() => {
			if (markers.length < 1) {
				return;
			}
			for (let index in markers) {
				let marker = markers[index];
				this.addMarker(marker);
			}
			this.map.fitBounds(this.bounds);
		});
	}

	resetMarkers() {
		return new Promise((resolve) => {
			if (this.infoWindow) {
				this.infoWindow.close();
			}
			for (let index in this.markers) {
				this.markers[index].setMap(null);
			}
			this.bounds = new this.google.maps.LatLngBounds();
			this.cluster.clearMarkers();
			this.markers = [];
			resolve(true);
		});
	}

	addMarker(marker) {
		let color = window.getComputedStyle(document.body).getPropertyValue('--bs-secondary');
		let svg = `
			<svg xmlns="http://www.w3.org/2000/svg" width="31.63" height="44.91" viewBox="6.7233 -0.00146818 31.63 44.91">
				<path d="M22.588 44.912c3.777-5.259 7.54-10.486 10.81-16.084 2.238-3.832 4.371-8.027 4.897-12.48.193-1.634-.117-3.513-.513-5.098-.658-2.63-1.94-5.155-3.944-7.023C26.95-2.197 14.202-1.286 9.026 6.855c-1.06 1.668-1.72 3.596-2.046 5.538-.378 2.25-.365 4.378.217 6.591 1.305 4.965 4.122 9.666 6.837 13.975 1.886 2.991 3.833 5.955 5.95 8.789.7.938 1.549 2.63 2.604 3.164z" fill="${color}"/>
			</svg>
		`;

		const parser = new DOMParser();
		svg = parser.parseFromString(
			svg,
			"image/svg+xml",
		).documentElement

		const advancedMarker = new this.advancedMarkerElement({
			map: this.map,
			position: marker.position,
			title: marker.title,
			content: svg,
		});
		this.cluster.addMarker(advancedMarker);
		this.markers.push(advancedMarker);
		this.bounds.extend(marker.position);

		advancedMarker.addListener('gmp-click', () => {
			if (this.infoWindow) {
				this.infoWindow.close();
			}
			this.infoWindow = new this.google.maps.InfoWindow({
				content: this.dealers[marker.id].html,
				ariaLabel: marker.title,
			});
			this.infoWindow.open({
				map: this.map,
				anchor: advancedMarker
			});
		});
	}

	zoom() {
		this.map.fitBounds(this.bounds);
	}
}

export default GoogleMaps;
